import React from "react";
import { durationDisplay } from "../../../SoundClipEditor/Controls/Player";
import { useStore } from "utils/useStore";
import { AcxTranscriptionStore } from "../Stores/AcxTranscriptionStore";
import { observer } from "mobx-react";
import parser from "html-react-parser";
import { TranscriptionSearchResult } from "components/Evaluation/Stores/EvalStore";
import { SpeakerStore } from "../Stores/SpeakerStore/SpeakerStore";
import { getSpeakerColorByChannelOrPersona } from "Theme/utils";
import { ConversationSearch } from "../../ConversationSearch/ConversationSearch";

export default observer(function InputSearchTranscription({
    speakerStore,
    alignment = "right",
    disabled = false,
    inputWidth = "280px",
    onResultClick,
}: {
    speakerStore: SpeakerStore;
    alignment?: "left" | "right";
    disabled?: boolean;
    inputWidth?: string;
    onResultClick?: (searchResult: TranscriptionSearchResult) => void;
}) {
    const store = useStore(AcxTranscriptionStore);
    const searchResults = store.getSearchResults();

    return (
        <ConversationSearch
            alignment={alignment}
            disabled={disabled}
            inputWidth={inputWidth}
            searchString={store.searchString}
            onSearchStringChange={(value) => {
                store.searchString = value;
            }}
            results={(searchResults ?? []).map((result, index) => ({
                key: index,
                speaker: result.blurb
                    ? speakerStore.speakerChannelMap.get(result.channel)
                          ?.name ??
                      speakerStore.predictedSpeakerChannelMap.get(
                          result.channel,
                      ) ??
                      `Speaker ${result.channel + 1}`
                    : "Speaker Unknown",
                speakerColor: result.blurb
                    ? getSpeakerColorByChannelOrPersona(result.channel)
                    : undefined,
                timestamp: durationDisplay(result.startTime),
                content: parser(store.formatTextWithHighlights(result.stmt)),
                onSelect: () => {
                    if (result.phraseStartTime === undefined) return;
                    store.setScrollIndex(
                        store.getScrollIndexForTimestamp(
                            result.phraseStartTime,
                        ),
                    );
                    onResultClick?.(result);
                },
            }))}
        />
    );
});
